// services/bankService.ts
import axios from "axios";
import { BACKEND_URL } from "../../config/api";
import { sortByDate } from "../../helpers/sortDataByDate";
import { BankTransfertItem, PaginationParams } from "../../types/features/administration/VirementBancaire";

export const bankService = {
  async getTransfertsCanadaCmr(
    token: string,
    pagination?: PaginationParams,
    direction?: string
  ): Promise<BankTransfertItem[]> {
    try {
      const cleanedToken = token.replace(/^"|"$/g, "").trim();

      let url = `${BACKEND_URL}/transferts/${direction}/?skip=${pagination?.skip ?? 0}&limit=${pagination?.limit ?? 50}`;

      if (pagination?.status) {
        url += `&status=${pagination.status}`;
      }

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${cleanedToken}`,
          accept: "application/json",
        },
      });

      const sortedTransferts = sortByDate(
        response.data?.data?.items as BankTransfertItem[],
        (item) => item.transfert.created_at,
        "desc"
      );

      return sortedTransferts || [];
    } catch (error: any) {
      console.error("Erreur getTransfertsCanadaCmr:", error.response?.data);
      throw error;
    }
  },

  // Admin: Marquer le payout comme COMPLETED
  async completePayout(token: string, extensionId: string): Promise<any> {
    const cleanedToken = token.replace(/^"|"$/g, "").trim();
    const response = await axios.post(
      `${BACKEND_URL}/transferts/canada-cmr-banque/${extensionId}/complete`,
      {},
      { headers: { Authorization: `Bearer ${cleanedToken}`, accept: "application/json" } }
    );
    return response.data;
  },

  // Admin: Marquer le payout comme IN_PROGRESS
  async inProgressPayout(token: string, extensionId: string): Promise<any> {
    const cleanedToken = token.replace(/^"|"$/g, "").trim();
    const response = await axios.post(
      `${BACKEND_URL}/transferts/canada-cmr-banque/${extensionId}/in-progress`,
      {},
      { headers: { Authorization: `Bearer ${cleanedToken}`, accept: "application/json" } }
    );
    return response.data;
  },

  // Admin: Marquer le payout comme FAILED
  async failPayout(token: string, extensionId: string): Promise<any> {
    const cleanedToken = token.replace(/^"|"$/g, "").trim();
    const response = await axios.post(
      `${BACKEND_URL}/transferts/canada-cmr-banque/${extensionId}/fail`,
      {},
      { headers: { Authorization: `Bearer ${cleanedToken}`, accept: "application/json" } }
    );
    return response.data;
  },

  // Admin: Marquer le payout comme CANCELED
  async cancelPayout(token: string, extensionId: string): Promise<any> {
    const cleanedToken = token.replace(/^"|"$/g, "").trim();
    const response = await axios.post(
      `${BACKEND_URL}/transferts/canada-cmr-banque/${extensionId}/cancel`,
      {},
      { headers: { Authorization: `Bearer ${cleanedToken}`, accept: "application/json" } }
    );
    return response.data;
  },

  // Vérifier la clé de sécurité
  async verifySecurityKey(
    token: string,
    transfertId: string,
    data: { security_key: string; account_number?: string; phone_number?: string }
  ): Promise<any> {
    const cleanedToken = token.replace(/^"|"$/g, "").trim();
    const response = await axios.post(`${BACKEND_URL}/transferts/canada-cmr-banque/${transfertId}/verify-key`, data, {
      headers: { Authorization: `Bearer ${cleanedToken}`, accept: "application/json" },
    });
    return response.data;
  },
};
